import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DepotPieceElementAnnee, DepotPieceReutilisable, SourceDepot } from '@pieces-api';

export interface DownloadPieceRequest {
  idDemandePiece: string;
  fileName: string;
  originalFileName: string;
}

export interface UploadPieceRequest {
  pieceId: string;
  idDemandePiece: string;
  sourceDepot: SourceDepot;
  file: File;
}

export interface UpdateConcernStatusRequest {
  idDemandePiece: string;
  isConcerned: boolean;
}

export interface ReusePieceRequest {
  idDemandePiece: string;
  idDepot: string;
}

export interface PreviewReusableRequest {
  idDepot: string;
  nomFichier: string;
  typeMime: string;
}

export const piecesJustificativesActions = createActionGroup({
  source: 'Pieces Justificatives',
  events: {
    // Load pieces
    'Load Pieces': emptyProps(),
    'Load Pieces Success': props<{
      pieces: DepotPieceElementAnnee[] | null;
      reutilisables: DepotPieceReutilisable[] | null;
    }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Load Pieces Failure': props<{ error: any }>(),

    // Download piece
    'Download Piece': props<{ request: DownloadPieceRequest }>(),
    'Download Piece Success': props<{ fileName: string; originalFileName: string; blob: Blob }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Download Piece Failure': props<{ error: any }>(),

    // Upload piece (deposit or replace)
    'Upload Piece': props<{ request: UploadPieceRequest }>(),
    'Upload Piece Success': emptyProps(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Upload Piece Failure': props<{ error: any }>(),

    // Update concern status
    'Update Concern Status': props<{ request: UpdateConcernStatusRequest }>(),
    'Update Concern Status Success': emptyProps(),
    'Update Concern Status Failure': props<{ error: unknown }>(),

    // Reuse a previously deposited piece
    'Reuse Piece': props<{ request: ReusePieceRequest }>(),
    'Reuse Piece Success': emptyProps(),
    'Reuse Piece Failure': props<{ error: unknown }>(),

    // Preview a reusable deposit (open its blob in a new tab)
    'Preview Reusable': props<{ request: PreviewReusableRequest }>(),
    'Preview Reusable Success': props<{ blob: Blob; nomFichier: string; typeMime: string }>(),
    'Preview Reusable Failure': props<{ error: unknown }>(),

    // Clear error
    'Clear Error': emptyProps(),
  },
});
